import {
  TextProps as ChakraTextProps,
  Text as ChakraText,
} from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import React from 'react';

export type TextProps = ChakraTextProps & { params?: string[] };

export const Text: React.FC<TextProps> = ({ params, children, ...props }) => {
  const translate = useTranslate();
  return (
    <ChakraText cursor="text" {...props}>
      {translate(children, params)}
    </ChakraText>
  );
};
